import { ApiController } from '@yoop/base-client';
import type { UiUserActivityTabConfigurationResponse } from '@yoop/server-model/user-activity';
import type { UserProfileResponse } from '@yoop/server-model/user-account';

export class UserController extends ApiController {
  public getUserProfile(): Promise<UserProfileResponse> {
    return this.get('user/profile');
  }

  public getUserTabs(clientId: number): Promise<UiUserActivityTabConfigurationResponse> {
    return this.get('/user/activityConfiguration', { clientId });
  }

  public logout(): Promise<void> {
    return this.post('/auth/logout');
  }
}
